export type IdentifierType = number;

export interface BaseObjectParams {
  id?: IdentifierType;
}

export default abstract class BaseObject implements BaseObjectParams {
  static indexIterator = 0;
  static getNewIdentifier(): number {
    return BaseObject.indexIterator++;
  }

  id!: IdentifierType;

  applyParams(params = {}): void {
    Object.assign(this, params);
  }

  create(): BaseObject {
    this.id = BaseObject.getNewIdentifier();
    return this;
  }
}
